import styles from './style.postcss';

import React from 'react';
import classnames from 'classnames';
import RadialScoreDisplay from 'components/RadialScoreDisplay';
import PropTypes from 'prop-types';

const ProgressCardTd = (props) => <td className={classnames(styles.ProgressCardTd,
    props.className)}>
  <RadialScoreDisplay radius={25}
      circleStrokeWidth={2}
      edgeSize={70}
      forcedTextY={40}
      unit="percent"
      displayText
      formatText={(value) => {
        if (props.percent === null) {
          return '-';
        }
        return `${value}%`;
      }}
      circleStroke="transparent"
      value={props.percent} />
</td>;

ProgressCardTd.propTypes = {
  percent: PropTypes.number,
  className: PropTypes.string,
};

export default ProgressCardTd;



// WEBPACK FOOTER //
// ./components/TableView/Tds/ProgressCardTd/index.jsx